<template>
  <FlexColumn>
    <Label bold text="職歴" />
    <FlexRow
        v-for="(career, index) in careers"
        :key="index"
        wrap
    >
      <Label :text="career.company"/>
      <Label text="|"/>
      <Label :text="career.position"/>
      <Label :text="(career.period)"/>
    </FlexRow>
  </FlexColumn>
</template>

<script>
import Label from "@/components/atoms/Label";
import FlexColumn from "@/components/atoms/FlexColumn";
import FlexRow from "@/components/atoms/FlexRow";
import {mapGetters} from "vuex";
import moment from "moment";
export default {
  name: "ApplicantCareers",
  components: {FlexRow, FlexColumn, Label},
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('system', ['consts']),
    careers() {
      return this.applicant.careers.map(career => ({
        company: career.companyName,
        position: career.position,
        period: this.period(career.startAt, career.endAt)
      }))
    }
  },
  methods: {
    diffMonth(start, end) {
      if (end) {
        return moment(end).diff(start, 'month')
      }
      return moment().diff(start, 'month')
    },
    period(start, end) {
      const month = this.diffMonth(start, end)
      if(month < 12) {
        return `${month % 12}ヶ月`
      }
      const year = Math.floor(month / 12)
      if(month % 12) {
        return `${year}年${month % 12}ヶ月`
      }
      return `${year}年`
    }
  }
}
</script>

<style scoped>
</style>